import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider, MutationCache } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import useToast from 'components/V2/Toast';
import { useTranslate } from 'hooks/useTranslate';

const ReactQueryProvider = ({ children }) => {
  const { showToast } = useToast();
  const t = useTranslate();

  const queryClient = useMemo(() => {
    return new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          staleTime: 60 * 1000
        }
      },
      mutationCache: new MutationCache({
        onError: (error) => {
          showToast({
            title: t('toast_title.error_message'),
            message: t(error.response?.data?.message || '', {
              ...error.response?.data?.translate_params
            }),
            color: 'danger'
          });
        }
      })
    });
  }, [t]);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

ReactQueryProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ReactQueryProvider;
